export const BUTTON = 'button';
export const BUTTON_LOADING = 'button--loading';
export const MODAL = 'modal';
export const SNIPPET = 'snippet-products-productDetail';
